// extracted by mini-css-extract-plugin
export default {"container":"Book_container__T9ncv","title":"Book_title__TLpCZ","button":"Book_button__ViZGp"};